import QRCode from 'qrcode';
import logo from '../assets/infinity-ev-qr-icon.png?inline';
import { colours } from '../theme';

/** How much of the QR code's width the logo's white square covers. High error correction survives up to 30% hidden. */
const LOGO_SHARE = 0.24;

/**
 * A QR code as SVG with the Infinity EV triangle in the middle, on a white square. Uses the
 * highest error correction, so phones still read it with the centre covered. The logo is
 * embedded (a data: URL), so the SVG works anywhere, including the print window.
 */
export async function qrWithLogo(text: string): Promise<string> {
  const svg = await QRCode.toString(text, { type: 'svg', margin: 0, errorCorrectionLevel: 'H', color: { dark: colours.nearBlack, light: '#0000' } });
  const size = Number(/viewBox="0 0 (\d+) \d+"/.exec(svg)?.[1] ?? 0);
  if (!size) return svg;
  const box = Math.round(size * LOGO_SHARE);
  const at = (size - box) / 2;
  const pad = box * 0.12;
  const w = box - pad * 2;
  const h = w * (196 / 240); // the logo's proportions
  const square = `<rect x="${at}" y="${at}" width="${box}" height="${box}" rx="${box * 0.12}" fill="#FFFFFF"/>`;
  const image = `<image href="${logo}" x="${at + pad}" y="${at + (box - h) / 2}" width="${w}" height="${h}" preserveAspectRatio="xMidYMid meet"/>`;
  return svg.replace('</svg>', `${square}${image}</svg>`);
}
